import { PropsWithChildren } from "react";

export function FieldValueList(props: PropsWithChildren<{}>) {
    return (
        <div className="eac-field-value-list">
            {props.children}
        </div>
    );
}

export function FieldValue(props: PropsWithChildren<{ label: string }>) {
    return (
        <label className="eac-field-value">
            <strong>{props.label}</strong>
            {props.children}
        </label>
    );
}
